'use strict';

var angularModule = angular.module('t2g.common.data-access.booking', []);

module.exports = angularModule;

angularModule.factory('BookingResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/booking/:id/:action';

  var resource = $resource(
    resourceUrl,
    {},
    {
      accept: { method: 'POST', isArray: false, params: { action: 'accept', id: '@_id' } },
      confirm: { method: 'POST', isArray: false, params: { action: 'confirm', id: '@_id' } },
      decline: { method: 'POST', isArray: false, params: { action: 'decline', id: '@_id' } },
      setProcessed: {
        method: 'POST',
        isArray: false,
        params: { action: 'set-processed', id: null },
      },
      getAll: { method: 'GET', isArray: false, params: { action: 'all' } },
      get: { method: 'GET', isArray: false },
    },
  );

  return resource;
});

angularModule.factory('BookingDA', function(BookingResource, UserSession) {
  return {
    getAll: function() {
      return BookingResource.getAll({ id: UserSession.getOffice() }).$promise;
    },
    setProcessed: function(booking) {
      return BookingResource.setProcessed({
        officeId: booking.officeId,
        bookingIds: booking.ids,
      }).$promise;
    },
    getUnprocessed: function() {
      return BookingResource.get({ id: UserSession.getOffice() }).$promise;
    },
    accept: function(booking) {
      return BookingResource.accept(booking).$promise;
    },
    confirm: function(booking) {
      return BookingResource.confirm(booking).$promise;
    },
    decline: function(booking) {
      return BookingResource.decline(booking).$promise;
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/booking.js